import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './index.css';
import './styles/brand-colors.css';
import './styles/brand-shell.css';
import './styles/brand-text.css';
import './styles/form.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { applyBrandVariables } from './utils/branding';

// Default brand colours on :root before first render; each shell then applies its own organization.
applyBrandVariables({});

// MSAL is no longer loaded here. It is loaded on demand:
//  - Login.jsx: when the user clicks "Sign in with Microsoft"
//  - MicrosoftRedirectHandler.jsx: only when the page is a return from Microsoft

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);